export const SvgTypeDocument = () => (
  <svg width="64" height="76" viewBox="0 0 64 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="16" y="5" width="48" height="59" rx="8" fill="#F1F5F9" />
    <rect y="10" width="32" height="31" rx="4" fill="#DEE6FE" fillOpacity="0.5" />
    <g opacity="0.8" filter="url(#filter0_f_1_148)">
      <ellipse cx="34.5" cy="68.5" rx="16.5" ry="1.5" fill="#D1D8E6" />
    </g>
    <path
      d="M42.9623 4.0499C42.6248 4.0499 39.7898 3.7124 37.4273 3.7124C35.3348 3.7124 33.9173 4.1174 33.4448 4.3874C33.2423 4.5224 32.8373 4.7249 32.4998 4.9949C32.1623 4.6574 31.7573 4.5224 31.6223 4.3874C31.0823 4.1174 29.7323 3.7124 27.6398 3.7124C25.2098 3.7124 22.3748 4.0499 22.0373 4.0499C21.0248 4.1174 20.2148 4.9274 20.2148 5.9399V20.9924C20.2148 22.0049 21.0248 22.8149 22.0373 22.8824H22.1048C22.3748 22.8149 23.7923 22.6799 25.3448 22.5449C28.1123 22.3424 29.1923 22.5449 29.5973 22.6124C29.7998 22.6124 30.0698 22.7474 30.3398 22.8149C30.9473 23.0174 31.6223 23.2199 32.3648 23.2199C32.9723 23.2199 33.6473 23.0174 34.2548 22.8149C34.7273 22.6799 35.1998 22.5449 35.4023 22.5449C35.4698 22.5449 35.5373 22.5449 35.6048 22.4774C38.7773 22.0049 42.5573 22.7474 42.5573 22.7474H42.6923C43.7048 22.7474 44.5823 21.9374 44.5823 20.8574V5.9399C44.7848 4.9274 43.9748 4.1174 42.9623 4.0499ZM22.7798 9.9224C23.5223 9.7199 25.0073 9.3824 27.3698 9.3824C28.7873 9.3824 29.7323 9.6524 30.7448 10.1924C31.0823 10.3949 31.1498 10.7999 31.0148 11.0699C30.8798 11.2724 30.6773 11.4074 30.4073 11.4074C30.2723 11.4074 30.2048 11.4074 30.0698 11.3399C29.2598 10.8674 28.5173 10.7324 27.3023 10.7324C25.0748 10.7324 23.7248 11.0699 23.0498 11.2724C22.7123 11.3399 22.3073 11.1374 22.2398 10.7999C22.2398 10.3274 22.4423 9.9899 22.7798 9.9224ZM31.1498 16.4024C31.0148 16.6724 30.8123 16.8074 30.5423 16.8074C30.4748 16.8074 30.3398 16.8074 30.2723 16.7399C30.2723 16.7399 28.7198 16.0649 27.4373 16.0649C25.2773 16.0649 24.4673 16.2674 23.6573 16.4699C23.5223 16.5374 23.3873 16.5374 23.2523 16.6049C22.9148 16.6724 22.5098 16.4699 22.4423 16.1324C22.3748 15.7949 22.5773 15.3899 22.9148 15.3224C23.0498 15.2549 23.1848 15.2549 23.3198 15.1874C24.1973 14.9849 25.0748 14.7149 27.4373 14.7149C29.0573 14.7149 30.7448 15.4574 30.8798 15.5249C31.1498 15.7274 31.2848 16.0649 31.1498 16.4024ZM42.6248 10.5299C42.5573 10.8674 42.2198 11.1374 41.8148 11.0699C40.1273 10.7324 38.9123 10.5299 37.3598 10.5974C35.8748 10.5974 34.8623 11.1374 34.7948 11.1374C34.7273 11.2049 34.5923 11.2049 34.4573 11.2049C34.2548 11.2049 33.9848 11.0699 33.8498 10.8674C33.6473 10.5299 33.7823 10.1249 34.1198 9.9899C34.1873 9.9899 35.4698 9.2474 37.2923 9.2474C38.9798 9.1124 40.2623 9.3824 42.0848 9.7199C42.4898 9.7874 42.6923 10.1924 42.6248 10.5299Z"
      fill="url(#paint0_linear_1_148)"
    />
    <path
      d="M22.565 10.21C23.3075 10.0075 24.7925 9.67 27.155 9.67C28.5725 9.67 29.5175 9.94 30.53 10.48C30.8675 10.6825 30.935 11.0875 30.8 11.3575C30.665 11.56 30.4625 11.695 30.1925 11.695C30.0575 11.695 29.99 11.695 29.855 11.6275C29.045 11.155 28.3025 11.02 27.0875 11.02C24.86 11.02 23.51 11.3575 22.835 11.56C22.4975 11.6275 22.0925 11.425 22.025 11.0875C22.025 10.615 22.2275 10.2775 22.565 10.21ZM30.935 16.69C30.8 16.96 30.5975 17.095 30.3275 17.095C30.26 17.095 30.125 17.095 30.0575 17.0275C30.0575 17.0275 28.505 16.3525 27.2225 16.3525C25.0625 16.3525 24.2525 16.555 23.4425 16.7575C23.3075 16.825 23.1725 16.825 23.0375 16.8925C22.7 16.96 22.295 16.7575 22.2275 16.42C22.16 16.0825 22.3625 15.6775 22.7 15.61C22.835 15.5425 22.97 15.5425 23.105 15.475C23.9825 15.2725 24.86 15.0025 27.2225 15.0025C28.8425 15.0025 30.53 15.745 30.665 15.8125C30.935 16.015 31.07 16.3525 30.935 16.69ZM42.41 10.8175C42.3425 11.155 42.005 11.425 41.6 11.3575C39.9125 11.02 38.6975 10.8175 37.145 10.885C35.66 10.885 34.6475 11.425 34.58 11.425C34.5125 11.4925 34.3775 11.4925 34.2425 11.4925C34.04 11.4925 33.77 11.3575 33.635 11.155C33.4325 10.8175 33.5675 10.4125 33.905 10.2775C33.9725 10.2775 35.255 9.535 37.0775 9.535C38.765 9.4 40.0475 9.67 41.87 10.0075C42.275 10.075 42.4775 10.48 42.41 10.8175Z"
      fill="url(#paint1_linear_1_148)"
    />
    <defs>
      <filter
        id="filter0_f_1_148"
        x="12"
        y="61"
        width="45"
        height="15"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur_1_148" />
      </filter>
      <linearGradient id="paint0_linear_1_148" x1="48.5" y1="29.5" x2="45" y2="-2" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF9F0F" />
        <stop offset="0.919339" stopColor="#FFB682" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_148"
        x1="48.2852"
        y1="29.7876"
        x2="44.7852"
        y2="-1.7124"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.919339" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export const SvgTypeWebsite = () => (
  <svg width="72" height="77" viewBox="0 0 72 77" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="17" y="3" width="48" height="59" rx="8" fill="#F1F5F9" />
    <rect x="7" y="10" width="30" height="30" rx="4" fill="url(#paint0_linear_1_163)" />
    <rect x="15" y="19" width="14" height="2" rx="1" fill="white" />
    <rect x="15" y="25" width="10" height="2" rx="1" fill="white" />
    <g filter="url(#filter0_b_1_163)">
      <circle cx="33.5" cy="38.5" r="9.5" fill="white" fillOpacity="0.8" />
      <circle cx="33.5" cy="38.5" r="8.5" stroke="#BDCBEC" strokeWidth="2" />
    </g>
    <path
      d="M23.7063 44.9734C24.6322 44.0475 26.1334 44.0475 27.0593 44.9734C27.9852 45.8993 27.9852 47.4005 27.0593 48.3264L23.0298 52.3559C22.1039 53.2818 20.6027 53.2818 19.6768 52.3559C18.7509 51.43 18.7509 49.9288 19.6768 49.0029L23.7063 44.9734Z"
      fill="url(#paint1_linear_1_163)"
    />
    <g opacity="0.8" filter="url(#filter1_f_1_163)">
      <ellipse cx="41.5" cy="69.5" rx="16.5" ry="1.5" fill="#D1D8E6" />
    </g>
    <defs>
      <filter
        id="filter0_b_1_163"
        x="21"
        y="26"
        width="25"
        height="25"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_163" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_163" result="shape" />
      </filter>
      <filter
        id="filter1_f_1_163"
        x="19"
        y="62"
        width="45"
        height="15"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur_1_163" />
      </filter>
      <linearGradient id="paint0_linear_1_163" x1="22" y1="37.75" x2="22" y2="1.00001" gradientUnits="userSpaceOnUse">
        <stop stopColor="#447EFF" />
        <stop offset="1" stopColor="#85ABFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_163"
        x1="25.1034"
        y1="59.7825"
        x2="12.2502"
        y2="46.9293"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.434783" stopColor="#767676" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </svg>
);

export const SvgSetting = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3387 6.35298L16.82 5.4529C16.3812 4.6913 15.4087 4.42856 14.6461 4.86556C14.283 5.07942 13.8499 5.14009 13.4421 5.0342C13.0342 4.92832 12.6853 4.66456 12.4722 4.30111C12.3351 4.07009 12.2614 3.80696 12.2586 3.53833C12.271 3.10765 12.1085 2.6903 11.8082 2.38136C11.5078 2.07241 11.0952 1.89818 10.6644 1.89836H9.61938C9.19727 1.89836 8.79256 2.06656 8.4948 2.36575C8.19704 2.66494 8.03078 3.07046 8.0328 3.49256C8.02029 4.36407 7.3102 5.06397 6.4386 5.06388C6.16997 5.06109 5.90684 4.98742 5.67583 4.85031C4.91318 4.41331 3.94072 4.67604 3.50191 5.43764L2.94509 6.35298C2.5068 7.11363 2.76596 8.08547 3.5248 8.52689C4.01805 8.81167 4.32191 9.33796 4.32191 9.90751C4.32191 10.4771 4.01805 11.0034 3.5248 11.2881C2.76693 11.7266 2.50749 12.6961 2.94509 13.4544L3.4714 14.3621C3.677 14.7331 4.02197 15.0069 4.42996 15.1228C4.83795 15.2388 5.27533 15.1874 5.64531 14.98C6.00903 14.7677 6.44245 14.7096 6.84925 14.8185C7.25604 14.9273 7.60249 15.1942 7.8116 15.5597C7.94871 15.7907 8.02239 16.0538 8.02518 16.3225C8.02518 17.2029 8.73893 17.9167 9.61938 17.9167H10.6644C11.5419 17.9167 12.2544 17.2076 12.2586 16.3301C12.2565 15.9067 12.4239 15.5 12.7233 15.2006C13.0227 14.9012 13.4294 14.7339 13.8528 14.7359C14.1208 14.7431 14.3828 14.8164 14.6156 14.9495C15.3762 15.3877 16.3481 15.1286 16.7895 14.3698L17.3387 13.4544C17.5513 13.0895 17.6096 12.655 17.5008 12.2469C17.392 11.8389 17.125 11.4911 16.759 11.2805C16.3929 11.0699 16.1259 10.7221 16.0171 10.3141C15.9083 9.90605 15.9667 9.47148 16.1793 9.1066C16.3175 8.86524 16.5176 8.66513 16.759 8.52689C17.5133 8.08571 17.7718 7.11954 17.3387 6.3606V6.35298Z"
      fill="white"
    />
    <ellipse cx="10.1455" cy="9.90752" rx="2.1968" ry="2.1968" fill="#7C68FB" />
  </svg>
);

export const SvgMessage = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0165 1.66667C5.17484 1.66667 1.6665 5.61667 1.6665 10C1.6665 11.4 2.07484 12.8417 2.7915 14.1583C2.92484 14.375 2.9415 14.65 2.84984 14.9083L2.2915 16.775C2.1665 17.225 2.54984 17.5583 2.97484 17.425L4.65817 16.925C5.1165 16.775 5.47484 16.9667 5.90067 17.225C7.11734 17.9417 8.63317 18.3083 9.99984 18.3083C14.1332 18.3083 18.3332 15.1167 18.3332 9.975C18.3332 5.54167 14.7498 1.66667 10.0165 1.66667Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.98337 11.0751C9.39171 11.0668 8.91671 10.5918 8.91671 10.0001C8.91671 9.41675 9.40004 8.93342 9.98337 8.94175C10.575 8.94175 11.05 9.41675 11.05 10.0084C11.05 10.5918 10.575 11.0751 9.98337 11.0751ZM6.14137 11.0751C5.55804 11.0751 5.07471 10.5918 5.07471 10.0084C5.07471 9.41677 5.54971 8.94177 6.14137 8.94177C6.73304 8.94177 7.20804 9.41677 7.20804 10.0084C7.20804 10.5918 6.73304 11.0668 6.14137 11.0751ZM12.7582 10.0084C12.7582 10.5918 13.2332 11.0751 13.8249 11.0751C14.4165 11.0751 14.8915 10.5918 14.8915 10.0084C14.8915 9.41675 14.4165 8.94175 13.8249 8.94175C13.2332 8.94175 12.7582 9.41675 12.7582 10.0084Z"
      fill="#7C68FB"
    />
  </svg>
);

export const SvgData = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3981 11.5743C14.9604 11.5743 15.4323 12.0383 15.3463 12.5936C14.8419 15.8603 12.0455 18.2857 8.67264 18.2857C4.94107 18.2857 1.9165 15.2612 1.9165 11.5305C1.9165 8.45677 4.25159 5.59361 6.88054 4.94624C7.44545 4.80677 8.0244 5.20414 8.0244 5.78572C8.0244 9.72607 8.15685 10.7454 8.9051 11.2998C9.65335 11.8541 10.5332 11.5743 14.3981 11.5743Z"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0768 8.293C18.1215 5.76142 15.0119 1.68072 11.2224 1.75089C10.9277 1.75616 10.6917 2.00177 10.6785 2.29563C10.5829 4.37721 10.7119 7.07458 10.7838 8.29738C10.8057 8.67809 11.1049 8.97721 11.4847 8.99914C12.7417 9.07107 15.5373 9.16931 17.5891 8.85879C17.868 8.81668 18.0724 8.57458 18.0768 8.293Z"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgDataActive = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3981 11.5743C14.9604 11.5743 15.4323 12.0384 15.3463 12.5936C14.8419 15.8603 12.0455 18.2857 8.67264 18.2857C4.94107 18.2857 1.9165 15.2612 1.9165 11.5305C1.9165 8.45677 4.25159 5.59362 6.88054 4.94625C7.44545 4.80677 8.0244 5.20414 8.0244 5.78572C8.0244 9.72607 8.15685 10.7454 8.9051 11.2998C9.65335 11.8541 10.5332 11.5743 14.3981 11.5743Z"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0768 8.293C18.1215 5.76142 15.0119 1.68072 11.2224 1.75089C10.9277 1.75616 10.6917 2.00177 10.6785 2.29563C10.5829 4.37721 10.7119 7.07458 10.7838 8.29738C10.8057 8.67809 11.1049 8.97721 11.4847 8.99914C12.7417 9.07107 15.5373 9.16931 17.5891 8.85879C17.868 8.81668 18.0724 8.57458 18.0768 8.293Z"
      stroke="#A395FC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgQa = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0307 2.30158H7.4865C5.77067 2.30158 4.2915 3.69242 4.2915 5.40908V14.3366C4.2915 16.1499 5.674 17.5958 7.4865 17.5958H14.144C15.8607 17.5958 17.2515 16.0541 17.2515 14.3366V6.69825L13.0307 2.30158Z"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8115 2.29183V4.716C12.8115 5.89933 13.769 6.85933 14.9515 6.86183C16.049 6.86433 17.1715 6.86517 17.2474 6.86017"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M12.6533 12.9648H8.15576"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M10.9519 8.838H8.15527"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgQaActive = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0307 2.30157H7.4865C5.77067 2.30157 4.2915 3.69241 4.2915 5.40907V14.3366C4.2915 16.1499 5.674 17.5957 7.4865 17.5957H14.144C15.8607 17.5957 17.2515 16.0541 17.2515 14.3366V6.69824L13.0307 2.30157Z"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8115 2.29184V4.71601C12.8115 5.89934 13.769 6.85934 14.9515 6.86184C16.049 6.86434 17.1715 6.86517 17.2474 6.86017"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M12.6533 12.9648H8.15576"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M10.9519 8.83799H8.15527"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgConversation = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3926 15.8916C13.8458 18.4386 10.0746 18.9889 6.98852 17.5617C6.53293 17.3783 6.15941 17.23 5.80431 17.23C4.81524 17.2359 3.58414 18.1949 2.9443 17.5558C2.30447 16.9159 3.26422 15.6838 3.26422 14.6888C3.26422 14.3337 3.12185 13.9668 2.93844 13.5103C1.51053 10.4247 2.06159 6.65224 4.60839 4.10601C7.8595 0.853694 13.1415 0.853694 16.3926 4.10517C19.6496 7.36251 19.6438 12.6401 16.3926 15.8916Z"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M13.7825 10.3442H13.79"
      stroke="#475467"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M10.4417 10.3442H10.4492"
      stroke="#475467"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M7.10091 10.3442H7.10841"
      stroke="#475467"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgConversationActive = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3926 15.8915C13.8458 18.4386 10.0746 18.9889 6.98852 17.5617C6.53293 17.3782 6.15941 17.23 5.80431 17.23C4.81524 17.2359 3.58414 18.1949 2.9443 17.5558C2.30447 16.9159 3.26422 15.6838 3.26422 14.6888C3.26422 14.3336 3.12185 13.9668 2.93844 13.5103C1.51053 10.4247 2.06159 6.65223 4.60839 4.106C7.8595 0.853683 13.1415 0.853683 16.3926 4.10516C19.6496 7.3625 19.6438 12.6401 16.3926 15.8915Z"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M13.7825 10.3442H13.79"
      stroke="#7C68FB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M10.4417 10.3442H10.4492"
      stroke="#7C68FB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M7.10091 10.3442H7.10841"
      stroke="#7C68FB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgHandleEdit = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8.3576 12.8286L8.85245 12.274C9.45962 11.5935 10.549 11.6819 11.0384 12.4515C11.4943 13.1683 12.4849 13.3042 13.117 12.7366L14.014 11.9313M1.98584 12.9799L4.8965 12.3934C5.05101 12.3623 5.19289 12.2862 5.30432 12.1747L11.8201 5.65538C12.1325 5.34281 12.1323 4.83615 11.8196 4.52385L10.4393 3.14513C10.1268 2.83295 9.62041 2.83316 9.30814 3.1456L2.79168 9.66564C2.68047 9.77691 2.60454 9.9185 2.57338 10.0727L1.98584 12.9799Z"
      stroke="#344054"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgHandleChat = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.9494 8.39995C14.9494 8.0962 14.7031 7.84995 14.3994 7.84995C14.0956 7.84995 13.8494 8.0962 13.8494 8.39995H14.9494ZM13.8557 10.9853L13.3527 10.7629C13.311 10.8571 13.2967 10.9611 13.3112 11.063L13.8557 10.9853ZM11.132 13.9822L11.2654 13.4486C11.129 13.4145 10.9848 13.4339 10.8624 13.5028L11.132 13.9822ZM14.4006 14.7993L14.2672 15.3329C14.4448 15.3773 14.6329 15.3304 14.7689 15.2078C14.9049 15.0851 14.9709 14.9028 14.9451 14.7216L14.4006 14.7993ZM6.90187 2.65263C7.2003 2.59602 7.39634 2.3082 7.33973 2.00976C7.28312 1.71133 6.9953 1.51529 6.69686 1.5719L6.90187 2.65263ZM13.8494 8.39995C13.8494 9.24192 13.6718 10.041 13.3527 10.7629L14.3587 11.2076C14.7386 10.3483 14.9494 9.39802 14.9494 8.39995H13.8494ZM7.99936 14.25C4.7685 14.25 2.14937 11.6308 2.14937 8.39995H1.04937C1.04937 12.2383 4.16099 15.35 7.99936 15.35V14.25ZM10.8624 13.5028C10.0166 13.9785 9.0405 14.25 7.99936 14.25V15.35C9.23423 15.35 10.3954 15.0274 11.4016 14.4616L10.8624 13.5028ZM14.534 14.2658L11.2654 13.4486L10.9986 14.5158L14.2672 15.3329L14.534 14.2658ZM13.3112 11.063L13.8561 14.8771L14.9451 14.7216L14.4002 10.9075L13.3112 11.063ZM2.14937 8.39995C2.14937 5.5446 4.19561 3.16599 6.90187 2.65263L6.69686 1.5719C3.48106 2.18192 1.04937 5.00637 1.04937 8.39995H2.14937ZM13.8494 3.59995C13.8494 4.62168 13.0211 5.44995 11.9994 5.44995V6.54995C13.6286 6.54995 14.9494 5.22919 14.9494 3.59995H13.8494ZM11.9994 5.44995C10.9776 5.44995 10.1494 4.62168 10.1494 3.59995H9.04936C9.04936 5.22919 10.3701 6.54995 11.9994 6.54995V5.44995ZM10.1494 3.59995C10.1494 2.57822 10.9776 1.74995 11.9994 1.74995V0.649951C10.3701 0.649951 9.04936 1.97071 9.04936 3.59995H10.1494ZM11.9994 1.74995C13.0211 1.74995 13.8494 2.57822 13.8494 3.59995H14.9494C14.9494 1.97071 13.6286 0.649951 11.9994 0.649951V1.74995Z"
      fill="#344054"
    />
  </svg>
);

export const SvgHandleDatasets = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M10.0001 1.6001V4.0001C10.0001 4.44193 10.3582 4.8001 10.8001 4.8001H13.2001M5.60005 4.8001H7.20005M5.60005 7.2001H10.4001M5.60005 9.6001H10.4001M12.0001 2.8001C11.644 2.48153 11.2745 2.10368 11.0413 1.85828C10.8861 1.69499 10.6716 1.6001 10.4463 1.6001H4.39987C3.51621 1.6001 2.79987 2.31644 2.79987 3.20009L2.7998 12.8001C2.7998 13.6837 3.51614 14.4001 4.3998 14.4001L11.5998 14.4001C12.4835 14.4001 13.1998 13.6838 13.1998 12.8001L13.2 4.31865C13.2001 4.11409 13.122 3.91745 12.98 3.77019C12.7175 3.49786 12.2791 3.04978 12.0001 2.8001Z"
      stroke="#344054"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SvgHandleDashboard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.62363 14.5882C10.9503 14.5882 13.6472 11.8914 13.6472 8.56468H7.62363L7.62366 2.54114C4.29694 2.54112 1.6001 5.23797 1.6001 8.56469C1.6001 11.8914 4.29692 14.5882 7.62363 14.5882Z"
      stroke="#344054"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2589 1.41162V5.87135H14.4001V5.5528C14.4001 3.26569 12.546 1.41162 10.2589 1.41162Z"
      stroke="#344054"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SvgHandleConversations = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2.0001 5.2001H14.0001M12.0001 8.0001H4.0001M8.8001 11.2001H4.0001M4.0001 14.4001H12.0001C13.3256 14.4001 14.4001 13.3256 14.4001 12.0001V4.0001C14.4001 2.67461 13.3256 1.6001 12.0001 1.6001H4.0001C2.67461 1.6001 1.6001 2.67461 1.6001 4.0001V12.0001C1.6001 13.3256 2.67461 14.4001 4.0001 14.4001Z"
      stroke="#344054"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SvgHandleDelete = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2.66675 4.11765H13.3334M6.66675 11.1765V6.94118M9.33341 11.1765V6.94118M10.6667 14H5.33341C4.59704 14 4.00008 13.3679 4.00008 12.5882V4.82353C4.00008 4.43368 4.29856 4.11765 4.66675 4.11765H11.3334C11.7016 4.11765 12.0001 4.43368 12.0001 4.82353V12.5882C12.0001 13.3679 11.4031 14 10.6667 14ZM6.66675 4.11765H9.33341C9.7016 4.11765 10.0001 3.80161 10.0001 3.41176V2.70588C10.0001 2.31603 9.7016 2 9.33341 2H6.66675C6.29856 2 6.00008 2.31603 6.00008 2.70588V3.41176C6.00008 3.80161 6.29856 4.11765 6.66675 4.11765Z"
      stroke="#F04438"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgAgent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#9280F3"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M6 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z" />
    <path d="M12 2v2" />
    <path d="M9 12v9" />
    <path d="M15 12v9" />
    <path d="M5 16l4 -2" />
    <path d="M15 14l4 2" />
    <path d="M9 18h6" />
    <path d="M10 8v.01" />
    <path d="M14 8v.01" />
  </svg>
);

export const SvgRobot = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#9280F3">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M18 3a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-4.724l-4.762 2.857a1 1 0 0 1 -1.508 -.743l-.006 -.114v-2h-1a4 4 0 0 1 -3.995 -3.8l-.005 -.2v-8a4 4 0 0 1 4 -4zm-2.8 9.286a1 1 0 0 0 -1.414 .014a2.5 2.5 0 0 1 -3.572 0a1 1 0 0 0 -1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0 -.014 -1.414m-5.69 -4.286h-.01a1 1 0 1 0 0 2h.01a1 1 0 0 0 0 -2m5 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2" />
  </svg>
);

export const SvgGeneralAgent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2.32031C12.8284 2.32031 13.4999 2.99296 13.5 3.82129C13.4999 4.26461 13.3059 4.66201 13 4.93652V6.67969H18C19.1 6.67969 20 7.57969 20 8.67969V19.6797C19.9997 20.7795 19.0998 21.6797 18 21.6797H6C4.90016 21.6797 4.00027 20.7795 4 19.6797V8.67969C4 7.57969 4.9 6.67969 6 6.67969H11V4.93652C10.6941 4.66201 10.5001 4.26461 10.5 3.82129C10.5001 2.99296 11.1716 2.32031 12 2.32031ZM6 19.6797H18V8.67969H6V19.6797ZM2.86816 10.9014C2.93196 10.8757 3 10.9243 3 10.9932V16.3643C3 16.4331 2.93196 16.4817 2.86816 16.4561C1.77194 16.0103 1.0002 14.9383 1 13.6797C1 12.4208 1.77166 11.3472 2.86816 10.9014ZM21.1318 10.9014C22.2283 11.3472 23 12.4208 23 13.6797C22.9998 14.9383 22.2281 16.0103 21.1318 16.4561C21.068 16.4817 21 16.4331 21 16.3643V10.9932C21 10.9243 21.068 10.8757 21.1318 10.9014ZM9 12.1797C9.83 12.1797 10.5 12.8497 10.5 13.6797C10.4997 14.5095 9.82984 15.1797 9 15.1797C8.17016 15.1797 7.50026 14.5095 7.5 13.6797C7.5 12.8497 8.17 12.1797 9 12.1797ZM15 12.1797C15.83 12.1797 16.5 12.8497 16.5 13.6797C16.4997 14.5095 15.8298 15.1797 15 15.1797C14.1702 15.1797 13.5003 14.5095 13.5 13.6797C13.5 12.8497 14.17 12.1797 15 12.1797ZM21.208 3.19434C21.3208 2.93563 21.6792 2.93563 21.792 3.19434L21.9463 3.54688C22.221 4.17687 22.7157 4.67871 23.333 4.95312L23.8076 5.16406C24.064 5.27829 24.0639 5.65138 23.8076 5.76562L23.3594 5.96582C22.7262 6.24734 22.2221 6.76752 21.9521 7.41895L21.7939 7.80078C21.6836 8.06635 21.3166 8.06635 21.2061 7.80078L21.0479 7.41895C20.7779 6.76751 20.2738 6.24734 19.6406 5.96582L19.1924 5.76562C18.9361 5.65139 18.936 5.27827 19.1924 5.16406L19.667 4.95312C20.2844 4.67868 20.78 4.17696 21.0547 3.54688L21.208 3.19434Z"
      fill="#6F5EE2"
    />
  </svg>
);

export const SvgCatalogAgent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 2.00388L14 4.00388H5V20.0039H19V13.0039L21 12.0039V21.0039C21 21.5562 20.5523 22.0039 20 22.0039H4C3.44772 22.0039 3 21.5562 3 21.0039V3.00388C3.00006 2.45163 3.44776 2.00388 4 2.00388H15ZM16 17H8V15H16V17ZM16 13H8V11H16V13ZM18.5332 2.31052C18.7137 1.89644 19.2864 1.89646 19.4668 2.31052L19.7139 2.87595C20.1534 3.88442 20.9449 4.68763 21.9326 5.12692L22.6924 5.46481C23.1026 5.64767 23.1026 6.24486 22.6924 6.4277L21.9746 6.74704C20.9615 7.19769 20.1556 8.03044 19.7236 9.07321L19.4707 9.68454C19.2943 10.1104 18.7059 10.1104 18.5293 9.68454L18.2764 9.07321C17.8445 8.03043 17.0385 7.19769 16.0254 6.74704L15.3076 6.4277C14.8975 6.24486 14.8974 5.64765 15.3076 5.46481L16.0674 5.12692C17.0552 4.68759 17.8476 3.88459 18.2871 2.87595L18.5332 2.31052ZM13 8.99997H8V6.99997H13V8.99997Z"
      fill="#6F5EE2"
    />
  </svg>
);
